<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="journal-text" class="icon"></b-icon>
            <span>JOB CLAIM</span>
        </div>

        <div class="content">
            <div class="form mb-4">
                <job-list-filter @lookup="filterJobList($event)" :isClaim="true"></job-list-filter>
            </div>

            <perfect-scrollbar>
                <table>
                    <thead>
                        <tr>
                            <th class="action-column"></th>
                            <th>เลขที่เคลม</th>
                            <th>ข้อมูลผู้มาเคลม</th>
                            <th class="text-center">สถานะ</th>
                            <th>วันที่เปิดใบเคลม</th>
                            <th class="text-center">เคลมไปแล้ว</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in jobList" :key="index">
                            <td><div class="text-center"><router-link :to="'/job/claim?o=' + item.number" class="btn btn-sm btn-blue text-nowrap">ดูใบงาน</router-link></div></td>
                            <td>{{ item.number }}</td>
                            <td>
                                <span class="main">{{ item.license }}</span>
                                <span><b-icon icon="person" class="icon"></b-icon> {{ item.customer }}</span>
                            </td>
                            <td class="text-center"><div class="status" :class="item.status.style">{{ item.status.text }}</div></td>
                            <td class="date-time"><b-icon icon="clock"></b-icon> {{ item.openDate }}</td>
                            <td class="text-center">{{ item.claimDateCount }}</td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <loader-spinner :isDisplay="isLoading" class="mt-4 mb-4"></loader-spinner>

            <div class="no-data" v-if="jobList.length === 0 && !isLoading">
                <b-icon icon="exclamation-diamond"></b-icon>
                <span>ไม่มีรายการใบเคลม</span>
            </div>

            <paging @page="changePage($event)" :activePage="activePage" :pageSize="pageSize" :contentLength="jobList.length" class="mt-4"></paging>
        </div>
    </div>
</template>

<script>
import MixinJobTable from '@/components/job/JobTable';
import JobListFilter from '@/components/job/ListFilter';
import OptionLicensePlateProvince from '@/database/staticOption/LicensePlateProvince';
import DBJob from '@/database/Job';
import ModelJobFilter from '@/resources/models/JobFilter';

export default {
    mixins: [ MixinJobTable ],
    components: {
        JobListFilter
    },
    data() {
        return {
            jobList: [],
            jobFilter: ModelJobFilter.data(),
            isLoading: false,
            activePage: 1,
            pageSize: 50
        }
    },
    mounted() {
        this.loadJobList();
    },
    methods: {
        filterJobList(value) {
            this.jobFilter = value;
            this.loadJobList();
        },
        async loadJobList() {
            this.isLoading = true;
            this.jobList = [];
            const result = await DBJob.get();

            if (result.content && result.content.length > 0) {
                // Filter Job Type
                result.content = result.content.filter(x => x.jobType === this.$Constants.JOB_FORM_CLAIM);

                // Filter Result
                result.content = this.mixinsJobTable_FilterResult(result.content);

                // Map and Place into the Object
                this.jobList = this.mapViewData(result.content);
            }

            this.isLoading = false;
        },
        mapViewData(content) {
            const data = [];

            content.forEach((item) => {
                data.push({
                    number: item.number,
                    customer: [ item.customer.claimFirstName, item.customer.claimLastName ].join(' '),
                    license: [ item.customer.licensePlate, '(' + OptionLicensePlateProvince.service.getValueByKey(item.customer.licensePlateProvince) + ')'].join(' '),
                    status: this.mixinsJobTable_GetClaimStatusDisplay(item.status),
                    openDate: this.$AppUtility.displayTimeFormat(item.openDate),
                    claimDateCount: item.status !== this.$Constants.JOB_STATUS_COMPLETE ? this.mixinsJobTable_GetDifferenceDay(item.openDate) + ' วัน' : '-'
                });
            });

            return data;
        },
        changePage(value) {
            this.activePage = value;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/components/job/JobList.scss';
</style>